<template>
  <div id="dashboard" class="dashboard-page">
    <section id="fondo" class="score-page">
      <div class="container score-container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-8 col-lg-6">
            <div class="score-card mt-5">
              <!-- Título -->
              <p class="fXG blanco text-center py-5 mt-5">
              <img src="../assets/imgs/dominos/tu-marcador.png" class="w-100 tituloseccion" alt="Domino's Pizza">
            </p>

              <!-- Texto -->
              <div class="blanco fG pb-5" >
                <div>Estos son los</div>
                <div><strong>puntos que llevas</strong></div>
                <div>acumulados en la promoción:</div>
              </div>

              <!-- Total de puntos -->
              <div
                class="score-points-wrap"
                
              >
                <div class="score-points-circle">
                  <div class="score-points-number">{{ suma_puntos }}</div>
                  <div class="score-points-label">puntos</div>
                </div>
              </div>

              <!-- Tickets -->
              <div class="tickets-section" >
                <div class="tickets-title">
                  Tickets <strong>registrados:</strong>
                </div>

                <div
                  v-if="tickets3.length > 0"
                  class="tickets-list"
                >
                  <div
                    v-for="(ticket, index) in tickets3"
                    :key="ticket.id"
                    class="ticket-row"
                  >
                    <div class="ticket-name">
                      Ticket {{ (index + 1).toString().padStart(2, "0") }}
                    </div>

                    <div class="ticket-status">
                      ({{ getStatusLabel(ticket.status) }})
                    </div>

                    <!--
                    <div class="ticket-date">
                      {{
                        ticket.created_on_server
                          ? getFechaFormato(ticket.created_on_server.seconds)
                          : "-"
                      }}
                    </div>
                    -->

                    <!-- <div class="ticket-canal">{{ ticket.canal }}</div> -->

                    <!-- <div class="ticket-puntos">{{ ticket.puntos_x_ticket }}</div> -->
                  </div>
                </div>

                <div v-else class="blanco fG">
                  Aún no tienes tickets registrados.
                </div>
              </div>

              <!-- Texto inferior -->
              <div class="blanco fG pt-5" >
                ¡Sigue registrando tus compras de Domino’s
                para subir en la tabla y acercarte a los premios!
              </div>

              <!-- Botones -->
              <div class="actions-wrap">
                <!-- <router-link to="/dashboard" class="score-btn">
                  REGISTRAR TICKET
                </router-link> -->

                <router-link to="/ganadores" class="score-btn">
                  CONSULTAR GANADORES
                </router-link>
              </div>

              <!-- Contacto -->
              <div class="score-contact" data-aos="fade-up" data-aos-delay="380">
                Si necesitas apoyo comunícate al
                <a
                  href="tel:5530679927"
                  target="_blank"
                  class="pointer"
                  rel="noopener noreferrer"
                >
                  📞 55 3067 9927
                </a>.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import { ticketsCollection } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import * as fb from "../firebase";
import Footer from "@/components/Footer";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      suma_puntos: 0,
      tickets3: [],
    };
  },
  computed: {
    ...mapState(["userProfile", "tickets"]),
  },
  mounted() {
    this.getTickets2();
  },
  methods: {
    getFechaFormato(time) {
      return moment.unix(time).format("DD/MM/YY");
    },

    getStatusLabel(status) {
      if (!status) return "En revisión";

      const s = status.toString().toLowerCase().trim();

      if (s === "válido" || s === "valido" || s === "cerrado") {
        return "Válido";
      }

      if (
        s === "inválido" ||
        s === "invalido" ||
        s === "cerrado en otro ticket"
      ) {
        return "Rechazado";
      }

      if (s === "por validar" || s === "en revisión") {
        return "En Revisión";
      }

      return status;
    },

    async getTickets2() {
      this.$store.dispatch("showLoader", true);

      try {
        const docs = await ticketsCollection
          .where("user_id", "==", fb.auth.currentUser.uid)
          .where("status", "in", [
            "cerrado",
            "cerrado en otro ticket",
            "por validar",
            "En revisión",
            "valido",
            "válido",
            "inválido",
            "invalido",
          ])
          .get();

        this.tickets3 = [];
        this.suma_puntos = 0;

        docs.forEach((doc) => {
          let ticket = doc.data();
          ticket.id = doc.id;

          if (ticket.status === "inválido" || ticket.status === "invalido") {
            ticket.puntos_x_ticket = 0;
          } else {
            ticket.puntos_x_ticket = ticket.puntos_x_ticket || 0;
          }

          this.tickets3.push(ticket);

          if (
            ticket.status === "válido" ||
            ticket.status === "valido" ||
            ticket.status === "cerrado"
          ) {
            this.suma_puntos += parseInt(ticket.puntos_x_ticket || 0);
          }
        });

        this.tickets3.sort(this.custom_sort);
      } catch (error) {
        console.error("Error al obtener tickets:", error);
      }

      this.$store.dispatch("showLoader", false);
    },

    custom_sort(a, b) {
      const getTime = (ticket) => {
        if (!ticket.created_on_server) return 0;
        if (ticket.created_on_server.seconds) {
          return ticket.created_on_server.seconds * 1000;
        }
        if (ticket.created_on_server instanceof Date) {
          return ticket.created_on_server.getTime();
        }
        if (typeof ticket.created_on_server === "number") {
          return ticket.created_on_server * 1000;
        }
        return 0;
      };

      return getTime(a) - getTime(b);
    },
  },
};
</script>

<style lang="scss" scoped>
.score-page {
  min-height: 100vh;
  background: #0d95df;
  padding: 30px 0 60px;
}

.score-container {
  max-width: 1500px;
}

.score-card {
  color: #fff;
  text-align: center;
  padding: 10px 10px 30px;
}

.score-title-box {
  border: 1px solid rgba(255, 255, 255, 0.7);
  display: inline-block;
  padding: 10px 22px;
  margin-bottom: 24px;
}

.score-title {
  margin: 0;
  font-size: 2.2rem;
  font-weight: 800;
  line-height: 1;
}

.score-subtitle {
  font-size: 1.15rem;
  line-height: 1.15;
  margin-bottom: 26px;
}

.score-subtitle strong {
  font-weight: 800;
}

.score-points-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 28px;
}

.score-points-circle {
  width: 185px;
  height: 185px;
  border-radius: 50%;
  background: rgba(5, 70, 130, 0.28);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.score-points-number {
  font-size: 5rem;
  line-height: 0.9;
  font-weight: 900;
  color: #f3f3f3;
}

.score-points-label {
  font-size: 1.5rem;
  font-weight: 800;
  margin-top: 6px;
}

.tickets-section {
  margin-top: 10px;
}

.tickets-title {
  font-size: 2rem;
  margin-bottom: 18px;
}

.tickets-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ticket-row {
  background: rgba(0, 82, 145, 0.45);
  border-radius: 4px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 1.2rem;
}

.ticket-name {
  font-weight: 500;
}

.ticket-status {
  font-weight: 500;
  text-align: right;
}

.no-tickets {
  background: rgba(0, 82, 145, 0.35);
  border-radius: 4px;
  padding: 14px;
  font-size: 1rem;
}

.score-message {
  margin: 22px auto 0;
  max-width: 420px;
  font-size: 1rem;
  line-height: 1.3;
  font-weight: 600;
}

.actions-wrap {
  margin-top: 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.score-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 340px;
  min-height: 58px;
  background: #f53b16;
  color: #fff;
  font-size: 1.35rem;
  font-weight: 800;
  text-decoration: none;
  border-radius: 8px;
  transition: 0.2s ease;
  padding: 12px 20px;
}

.score-btn:hover {
  color: #fff;
  text-decoration: none;
  transform: translateY(-1px);
  opacity: 0.95;
}

.score-contact {
  margin-top: 40px;
  font-size: 1rem;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.95);
}

.score-contact a {
  color: #ffffff;
  font-weight: 700;
  text-decoration: none;
}

@media (max-width: 767px) {
  .score-page {
    padding: 20px 0 40px;
  }

  .score-title {
    font-size: 1.9rem;
  }

  .score-subtitle {
    font-size: 1rem;
    margin-bottom: 20px;
  }

  .score-points-circle {
    width: 150px;
    height: 150px;
  }

  .score-points-number {
    font-size: 4.1rem;
  }

  .score-points-label {
    font-size: 1.2rem;
  }

  .tickets-title {
    font-size: 1.7rem;
  }

  .ticket-row {
    font-size: 1rem;
    padding: 10px 12px;
  }

  .score-btn {
    max-width: 280px;
    min-height: 52px;
    font-size: 1.1rem;
  }

  .score-contact {
    font-size: 0.95rem;
  }
}
</style>